import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { notError, notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiTipoArticuloActualizar } from '../../api/apiTipoArticuloActualizar'

import { tipoArticuloActualizarComposeService } from '../../services/tipoArticuloActualizarComposeService'
import {
  TipoArticuloActualizarValidationSchema,
  tipoArticuloActualizarValidator,
} from '../../validator/tipoArticuloActualizar.validator'
import TipoArticuloForm from '../TipoArticuloForm'
import {
  TIPO_ARTICULO_INITIAL_VALUES,
  TipoArticuloInputProps,
  TipoArticuloProps,
} from '../../../../interfaces/tipoArticulo.ts'

interface OwnProps {
  keepMounted: boolean
  open: boolean
  tipoArticulo: TipoArticuloInputProps | undefined
  onClose: (value?: TipoArticuloProps) => void
}

type Props = OwnProps

/**
 * Formulario para editar un tipo de articulo
 * @param props
 * @constructor
 */
const TipoArticuloActualizarDialog: FunctionComponent<Props> = (props) => {
  const { onClose, open, tipoArticulo, keepMounted, ...other } = props
  const form = useForm<TipoArticuloInputProps>({
    defaultValues: {
      ...TIPO_ARTICULO_INITIAL_VALUES,
    },
    resolver: yupResolver<any, any, any>(TipoArticuloActualizarValidationSchema),
  })
  const confirm = useConfirm()

  /**
   * Actualizamos los datos
   * @param values
   */
  const onSubmit: SubmitHandler<TipoArticuloInputProps> = async (values) => {
    const val = await tipoArticuloActualizarValidator(values)
    const { codigo } = values
    const valuesModify = {
      descripcion: values.descripcion,
      notas: values.notas.map((item) => item.value),
    }
    if (val.length > 0) {
      notError(val.join('<br>'))
    } else {
      const { confirmed } = await confirm()
      if (!confirmed) return
      swalLoading()
      const resp = await apiTipoArticuloActualizar(codigo, valuesModify).catch((e) => {
        swalException(e)
      })
      if (resp) {
        notSuccess('Actualización exitosa')
        onClose(resp)
        swalClose()
      } else {
        console.log('error')
      }
    }
  }

  const onError = (error: any, e: any) => {
    console.error('Error:', error, e)
  }
  useEffect(() => {
    if (tipoArticulo && open) {
      form.reset(tipoArticuloActualizarComposeService(tipoArticulo))
    }
  }, [open])

  if (!tipoArticulo) {
    return null
  }

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '80vh' } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Editar Homologación de Unidad de Medida</DialogTitle>

      <DialogContent dividers>
        <TipoArticuloForm form={form} handleEdit={true} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus color={'error'} size={'small'} onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size={'small'}
          sx={{ mr: 2 }}
          variant={'contained'}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TipoArticuloActualizarDialog
